import {
  createAnalytics,
  createWebEventFactory,
  createEventStreamClient,
  createEventStreamSink,
  consoleSink,
  Sink,
  EventStreamEndpoint,
  createDomMutationDelegate,
  installWindowLifecycleListeners,
  installDocumentTitleListener,
  utmParameters,
  refTagParameters,
  clickIdParameters
} from "@amzn/ring-web-analytics";

const isLocalBuild = process.env.NODE_ENV === "development";

const ALLOW_PARAMETERS = [
  ...utmParameters,
  ...refTagParameters,
  ...clickIdParameters,
  "utm_campaignid"
];

function buildSink(eventStreamUrl: string): Sink {
  if (isLocalBuild) {
    return consoleSink;
  }

  return createEventStreamSink(
    createEventStreamClient({
      window,
      endpoint: eventStreamUrl as EventStreamEndpoint,
      group: "client.device",
      subgroup: "ring.neighbors.webapp"
    })
  );
}

export function initializeRWA(config: {
  RWA_ENABLED?: string;
  RWA_EVENT_STREAM_URL?: string;
}): void {
  const isEnabled = config.RWA_ENABLED === "true";

  if (!isEnabled || !config.RWA_EVENT_STREAM_URL || window.RWA) {
    return;
  }

  try {
    window.RWA = createAnalytics({
      window,
      clientId: "RingAgencyProfileUI",
      awsRegion: "us-east-1",
      cookieDomain: ".ring.com",
      referrer: window.document.referrer,
      sink: buildSink(config.RWA_EVENT_STREAM_URL),
      isTesting: false,
      eventFactory: createWebEventFactory({
        makeContext: () => ({
          locale: navigator.language || "en-US"
        }),
        includeQueryString: {
          allowParameters: ALLOW_PARAMETERS
        }
      }),
      customDimensions: {
        locale: navigator.language || "en-US"
      }
    });

    const domMutationDelegate = createDomMutationDelegate(window);
    installDocumentTitleListener(domMutationDelegate, window, window.RWA);
    installWindowLifecycleListeners(window, window.RWA);
    domMutationDelegate.invoke();
  } catch (error) {
    console.error("Failed to initialize RWA:", error);
  }
}
